<template>
    <ContainerLayout page="0" :padding="false">
        <template v-slot:navbar>
            <nav class="navbar navbar-expand navbar-light bg-white text-dark">
                <router-link :to="{ path: '', query: { ...$route.query } }" class="nav-link" @click.prevent="goBack">
                    <font-awesome-icon icon="arrow-left" class="text-dark" />
                </router-link>
                <div class="navbar-nav mr-auto">
                    <li class="nav-item">
                        <h6 class="nav-link mb-0 text-dark font-weight-bold">
                            {{ $route.meta.title }}
                        </h6>
                    </li>
                </div>
            </nav>
            <hr class="my-0" style="height: 1.5px;">
        </template>
        <div v-if="loaded_data" class="content px-1">
            <div class="p-2 my-1">
                <div v-for="(process, index) in transaction_processes" :key="index"
                    class="d-flex align-items-start my-1 position-relative pb-4">
                    <div class="d-flex flex-column align-items-center">
                        <!-- Icon circle -->
                        <div>
                            <font-awesome-icon icon="circle" :class="index == 0 ? 'text-main' : 'text-muted'"
                                style="font-size: 11px;" />
                        </div>

                        <!-- Line connecting circles -->
                        <div v-if="index != transaction_processes.length - 1"
                            class="line-connecting-circles position-absolute" style="top: 16px;"
                            :class="index == 0 ? 'bg-main' : 'bg-secondary'" />
                    </div>

                    <!-- Main content -->
                    <div class="w-100 ml-2 mt-1 d-flex flex-column align-items-start content-align">
                        <div class="w-100 d-flex align-items-center">
                            <div class="d-flex flex-column">
                                <small class="font-weight-bold" :class="index == 0 ? 'text-main' : 'text-muted'"
                                    style="font-size: 12px;">
                                    {{ process.created_by + ' - ' + formatDateDay(process.created_at) }}
                                </small>
                                <small class="font-weight-bold" :class="index == 0 ? 'text-main' : 'text-muted'"
                                    style="font-size: 12px;">
                                    {{ process.current_title }}
                                </small>
                                <small style="font-size: 12px;">
                                    {{ process.current_description }}
                                </small>
                            </div>
                        </div>
                    </div>

                    <!-- Time aligned with icon -->
                    <div class="mt-0">
                        <small style="font-size: 12px;">
                            {{ formatTime(process.created_at) }}
                        </small>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="content px-1">
            <div class="p-2 my-1">
                <div v-for="(item, index) in [1, 2, 3]" :key="index"
                    class="d-flex align-items-start my-1 position-relative pb-4">
                    <div class="skeleton-card" />
                </div>
            </div>
        </div>
    </ContainerLayout>
</template>
  
<script>
import ContainerLayout from "../ContainerLayout.vue";
import TransactionService from "@/services/transaction.service";
import moment from 'moment';
// import { ref } from 'vue';

export default {
    name: "TransactionStatusDetail",
    components: {
        ContainerLayout,
    },
    data() {
        return {
            loaded_data: false,
            loading: false,
            transaction_processes: [],
            isSpinning: false,
        };
    },
    computed: {
        currentUser() {
            return localStorage.getItem('loggedData') ? JSON.parse(localStorage.getItem('loggedData')).user : null;
        },
        currentCompany() {
            return localStorage.getItem('loggedData') ? JSON.parse(localStorage.getItem('loggedData')).user.company : null;
        },
    },
    created() {
        if (!this.$route.query.id) {
            this.$router.push("/transaction");
        } else {
            this.loadData();
        }
    },
    methods: {
        goBack() {
            this.navigateBackOrHome();
        },

        loadData() {
            this.loading = true;
            let loader = this.$loading.show();
            TransactionService
                .getProcessByTransactionId(this.$route.query.id)
                .then((response) => {
                    this.loading = false;
                    loader.hide();

                    if (response.data.status == "success") {
                        this.transaction_processes = response.data.data.data;
                        this.loaded_data = true;
                    } else {
                        this.$vueAlert.alert(response.data.message, null, 'error').then(() => {
                            this.goBack();
                        });
                    }
                })
                .catch((error) => {
                    this.loading = false;
                    loader.hide();

                    let errorMessage = this.$t('An error occurred');
                    if (error.response) {
                        if (error.response.status == 401) {
                            this.$store.dispatch("auth/logout");
                            this.$router.push('/login');
                            return; // Exit the function after handling 401
                        }

                        // Check if the message is available in the error response
                        if (error.response.data && error.response.data.message) {
                            errorMessage = error.response.data.message;
                        } else if (error.response.statusText) {
                            // Fallback to statusText if message is not available
                            errorMessage = error.response.statusText;
                        }
                    } else if (error.message) {
                        // Fallback to error.message if response is not available
                        errorMessage = error.message;
                    }

                    this.$vueAlert.alert(errorMessage, null, 'error').then(() => {
                        this.goBack();
                    });
                });
        },

        formatDateTime(date) {
            return moment(date).locale(this.currentUser ? this.currentUser.locale : 'id').format('DD MMM YYYY, HH:mm');
        },

        formatDateDay(date) {
            return moment(date).locale(this.currentUser ? this.currentUser.locale : 'id').format('dddd, DD MMM YYYY');
        },

        formatTime(date) {
            return moment(date).locale(this.currentUser ? this.currentUser.locale : 'id').format('HH:mm');
        },
    },
};
</script>

<style scoped>
.line-connecting-circles {
    width: 1px;
    height: 100%;
}

.skeleton-card {
    width: 100%;
    height: 120px;
    background-color: #e6e6e6;
    border-radius: 5px;
}
</style>